<input type="text" [(ngModel)]="_min" (keyup)="onKeyUp()" placeholder="min"/>
<input type="text" [(ngModel)]="_max" (keyup)="onKeyUp()" placeholder="max"/>
